import { screenShare } from "../../libs/roomnew";
import Sibilant from '../../libs/siblant-audio';
import { getLocalAudioTrack } from "../../room/functions";
import kinoTooltip from "../../room/kinoTooltip";
import NoiseSuppressionEffect from "./NoiseSuppressionEffect";

export default class NoiseSuppressionModule{
    constructor(){
        this.enabled=this.getStoredNoiseSuppressionState();
        this.active=false;
        this.siblant;
        this.onSpeakingEvent;
        this.icon=`<svg fill="none" height="20" width="20" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5a.833.833 0 00-.833.833v13.334a.833.833 0 001.666 0V3.333A.833.833 0 0010 2.5zM6.667 5a.833.833 0 00-.834.833v8.334a.833.833 0 001.667 0V5.833A.833.833 0 006.667 5zM2.5 8.333a.833.833 0 011.667 0v3.334a.833.833 0 01-1.667 0V8.333zm10 0a.833.833 0 011.667 0v3.334a.833.833 0 01-1.667 0V8.333zm3.333-2.5a.833.833 0 011.667 0v8.334a.833.833 0 01-1.667 0V5.833z" fill="#000"></path></svg>`;
    }

    async enableNoiseSuppression(setActive=true){
        const localAudio=getLocalAudioTrack();
        console.log("Enabling noise suppression on track",localAudio);
        if (!this.active && setActive) {
            if (!this.canEnableNoiseSuppression(localAudio)) {
                return false;
            }

            await localAudio.setEffect(new NoiseSuppressionEffect());
            this.noiseSuppressionEnabled();
            return true
        } else if (this.active && !setActive) {
            await localAudio.setEffect(undefined);
            this.noiseSuppressionDisabled();
            return true
        } else {
           console.log(`Noise suppression enabled state already: ${this.enabled}`);
           return false
        }
    };

    canEnableNoiseSuppression(localTrack){
        if(this.active){return true}
        if(!localTrack){
            return false;
        }
        const { channelCount } = localTrack.track.getSettings();
        if(channelCount > 1){
            console.log("Stereo audio tracks aren't currently supported, make sure the current local track is mono");
            return false;
        }
        if(screenShare.isSharing() && screenShare.desktopAudioTrack){
            console.log("Noise suppression can not be activated when sharing audio");
            return false;
        }
        return true;
    }
    storeNoiseSuppressionState(enabled){
        localStorage.setItem("noiseSuppression",enabled ? "true" : "false");
    };

    isNoiseSuppressionEnabledFirstTime(){
        return localStorage.getItem("noiseSuppressionTooltip") ? false :true;
    };

    setNoiseSuppressionTooltipShown(){
        localStorage.setItem("noiseSuppressionTooltip","shown");
    }

    getStoredNoiseSuppressionState(){
        if(localStorage.getItem("noiseSuppression")){
           const stored=localStorage.getItem("noiseSuppression");
           if(stored=="true"){
                return true;
           }else{
                return false
           }
        }
        return false;
    };

    noiseSuppressionEnabled(){
        this.enabled=true;
        this.active=true;
        this.storeNoiseSuppressionState(true)
        console.log('Noise suppression enabled.');
    };

    noiseSuppressionDisabled(){
        this.enabled=false;
        this.active=false;
        this.storeNoiseSuppressionState(false)
        console.log('Noise suppression disabled.');
        setTimeout(() => {
            this.hideTooltip();
        }, 1500);
    };

    isActive(){
        return this.active;
    };
    isEnabled(){
        return this.enabled;
    }

    showNoiseSuppressionTooltip(){
        const ns=this;    
        let toggleNoiseSuppression = $('<input/>',{
            type: 'checkbox',
            id:`toggleNoiseSuppressionPopup`,
            checked: ns.isActive()
        }).on('change', function(e){
            e.stopPropagation();
            if(ns.isActive()){
                if(ns.enableNoiseSuppression(false)){
                    $(this).prop('checked', false)
                }
            }else{
                if(ns.enableNoiseSuppression(true)){
                    $(this).prop('checked', true)
                }
            }
            console.log('Noise suppression ', $(this).is(':checked'))
        })

        let toggleNoiseSuppressionInput = $('<label/>',{
            class: 'switch pe-none',
            html: [toggleNoiseSuppression, `<span class="kino-slider round"></span>`]
        })
        let toggleNoiseSuppressionIcon = $('<span/>',{
            class: 'd-flex camera-settings-text-container px-0 justify-content-start',
            html: [ns.icon, '&nbsp;Noise Suppression']
        })

        let toggleNoiseSuppressionContainer=$('<div/>',{
            class: `d-flex no-hover w-100 justify-content-between align-items-center cursor-pointer kino-toggle px-2 py-3 ${!ns.canEnableNoiseSuppression(getLocalAudioTrack()) ? 'button-disabled' : ''}`,
            id: 'toggleNoiseSuppressionContainer',
            html: [toggleNoiseSuppressionIcon, toggleNoiseSuppressionInput]
        }).on('click', function(e){
            e.stopPropagation();
            toggleNoiseSuppression.trigger('change')
        })

        
        // let muteLockedText=$('<span/>',{
        //     html:'Activate Noise Suppression'
        // });
        // let noiseSuppressionBody=$("<div/>",{
        //     class:'d-flex align-items-center py-3',
        //     html:[muteLockedText,activeNoiseSuppression]
        // })

        let tooltipTitle=$('<span/>',{
            class:'tooltip-title',
            html:['Noisy microphone detected']
        })
        let tooltipContent=$("<div/>",{
            class:'mute-locked-tooltip-content',
            html:[tooltipTitle,toggleNoiseSuppressionContainer]
        });
        $(".noise-suppression-tooltip").remove();
        this.hideTooltip();
        this.noiseSuppressionTooltip = new kinoTooltip("toolbox-mic-container",tooltipContent, {
            left: '-135px',
            bottom: '120%',
            width:'325px',
            autohideSeconds:10,
            customClass:'align-center mute-locked-tooltip noise-suppression-tooltip'
        });
        this.noiseSuppressionTooltip.addTooltip();
        this.setNoiseSuppressionTooltipShown();
    };
    hideTooltip(){
        if(this.noiseSuppressionTooltip){
            this.noiseSuppressionTooltip.destroy();
            this.noiseSuppressionTooltip=undefined;
        } 
    }

    speakingEvent(stream){
        try {
        //    this.siblant = new Sibilant(stream,{threshold:0,smoothing:0.5});
        //    this.siblant.bind('speaking',()=>{
        //        console.log("Local user speaking")
        //        if(this.onSpeakingEvent){
        //             this.onSpeakingEvent();
        //        }
        //     });
        //    this.siblant.bind('stoppedSpeaking',()=>{
        //         this.siblant.suspend();
        //    });   
        } catch (error) {
            console.warn("Error attaching event to stream",error);
        }
       
    };


    showToolTipOnSpeak(){
        this.onSpeakingEvent=()=>{
            this.showNoiseSuppressionTooltip();
            this.onSpeakingEvent=undefined;
        };
    };

}